export type RegisterResponse = {
    id: string;
    email: string;
    name: string;
};

export type LoginResponse = {
    access: string;
    refresh: string;
    user: User;
};

export type TokenResponse = {
    access: string;
};

export type TokenErrorResponse = {
    detail: string;
    code: string;
};

export type Token = {
    token_type: 'access' | 'refresh';
    exp: number;
    iat: number;
    jti: string;
    sub: string;
};

export interface User {
    email: string;
    first_name: string;
    last_name: string;
    name: string;
    id: string;
    lang: string;
    is_superuser: boolean;
}

export enum PERMISSION {
    PARKING_DEVICES_STATUS = 'parking_devices_status',
    PARKING_QUICK_ACTIONS = 'parking_quick_actions',
    HOME = 'home',
    HOME_STATS = 'home_stats',
    HOME_LOG = 'home_log',
    PARKING_DEVICES = 'parking_devices',
    VEHICLE = 'vehicle',
    VEHICLE_STAY = 'vehicle_stay',
    VEHICLE_STAY_TAKE_PAYMENT = 'vehicle_stay_take_payment',
    VEHICLE_STAY_EXIT = 'vehicle_stay_exit',
    VEHICLE_STAY_MAKE_GUEST = 'vehicle_stay_make_guest',
    VEHICLE_STAY_CHANGE_PRICING = 'vehicle_stay_change_pricing',
    VEHICLE_MEMBERSHIP = 'vehicle_membership',
    VEHICLE_MEMBERSHIP_DETAILS_MANAGE = 'vehicle_membership_details_manage',
    VEHICLE_MEMBERSHIP_MEMBERS_MANAGE = 'vehicle_membership_members_manage',
    VEHICLE_MEMBERSHIP_VEHICLES_MANAGE = 'vehicle_membership_vehicles_manage',
    VEHICLE_FULL_LOG = 'vehicle_full_log',
    VEHICLE_VALIDATION = 'vehicle_validation',
    STATS = 'stats',
    STATS_VISITS = 'stats_visits',
    STATS_DURATIONS = 'stats_durations',
    STATS_TIMEFRAME = 'stats_timeframe',
    STATS_PAYMENTS = 'stats_payments',
    STATS_VALIDATIONS = 'stats_validations',
    STATS_GUEST_ACTIONS = 'stats_guest_actions',
    STATS_MANUAL_ACTIONS = 'stats_manual_actions',
    USERS = 'users',
    USERS_VIEW_STAFF = 'users_view_staff',
    USERS_MANAGE = 'users_manage',
    USERS_MANAGE_STAFF = 'users_manage_staff',
    USERS_INVITATION = 'users_invitation',
    USERS_INVITATION_VIEW_STAFF = 'users_invitation_view_staff',
    USERS_INVITATION_MANAGE = 'users_invitation_manage',
    USERS_INVITATION_MANAGE_STAFF = 'users_invitation_manage_staff',
    MONITORING = 'monitoring',
    PARKING_DETAILS_MANAGE = 'parking_details_manage',
    GUEST_REASONS_MANAGE = 'guest_reasons_manage',
    PROFILE = 'profile',
    PROFILE_MANAGE = 'profile_manage',
    PRICING = 'pricing',
    PRICING_MANAGE = 'pricing_manage',
    RESERVATIONS = 'reservations',
    RESERVATIONS_MANAGE = 'reservations_manage',
    RESERVATIONS_SETTINGS = 'reservations_settings',
    PARKING_ADMIN_SETTINGS = 'parking_admin_settings',
    SUBSCRIPTIONS = 'subscriptions',
    SUBSCRIPTIONS_MANAGE = 'subscriptions_manage',
    SUBSCRIPTIONS_SETTINGS = 'subscriptions_settings',
    PARKING_NOTIFICATIONS_SETTINGS = 'parking_notifications_settings',
    ADDITIONAL_SERVICES_MANAGE = 'additional_services_manage',
    RESERVATIONS_MANAGE_ADMIN = 'reservations_manage_admin',
    CASH_COLLECTIONS = 'cash_collections',
    STATS_CASH_COLLECTIONS = 'stats_cash_collection',
    VEHICLE_STAY_MAKE_GUEST_OTHER = 'vehicle_stay_make_guest_other',
    VEHICLE_STAY_CHANGE_IDENTIFIER = 'vehicle_stay_change_identifier',
}
